import { render, staticRenderFns } from "./DriverCreate.vue?vue&type=template&id=ec0c54fa"
import script from "../../controllers/driver/driver-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/driver/driver-create.js?vue&type=script&lang=js&external"
import style0 from "./DriverCreate.vue?vue&type=style&index=0&id=ec0c54fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports